<i18n lang="json">
{
  "ru": {
    "Новости банка": "Новости банка",
    "Мы стали ещё ближе!": "Мы стали ещё ближе!",
    "Открытие нового офиса в районе Турбаза": "Открытие нового офиса в районе Турбаза",
    "Скачивайте мобильное приложение": "Скачивайте мобильное приложение Амра и пополняйте мобильных операторов удалённо!",
    "Карты Visa и Mastercard": "Карты Visa и Mastercard снова работают в Абхазии",
    "Как вести бизнес с турецкими партнерами?": "Как вести бизнес с турецкими партнерами?",
    "Мы осуществляем переводы": "Мы осуществляем переводы в турецких лирах во все банки Турции. Если Вам необходимо срочно отправить платеж, мы готовы Вам в этом помочь.",
    "За более подробной информацией по номеру: +7 (840) 227-73-35": "За более подробной информацией по номеру: +7 (840) 227-73-35",
    "Онлайн-переводы с карт РФ прямо на карту или счёт Амра-Банк.": "Онлайн-переводы с карт РФ прямо на карту или счёт Амра-Банк."
  },
  "en": {
    "Новости банка": "Bank News",
    "Мы стали ещё ближе!": "We’ve become even closer!",
    "Открытие нового офиса в районе Турбаза": "Opening a new office in the Turbaza area",
    "Скачивайте мобильное приложение": "Download the Amra mobile app and top up mobile operators remotely!",
    "Карты Visa и Mastercard": "Visa and Mastercard are working again in Abkhazia",
    "Как вести бизнес с турецкими партнерами?": "How to do business with Turkish partners?",
    "Мы осуществляем переводы": "We make transfers in Turkish lira to all banks in Turkey. If you need to send a payment urgently, we are ready to help.",
    "За более подробной информацией по номеру: +7 (840) 227-73-35": "For more information, call: +7 (840) 227-73-35",
    "Онлайн-переводы с карт РФ прямо на карту или счёт Амра-Банк.": "Online transfers from Russian Federation cards directly to an Amra Bank card or account."
  },
  "tr": {
    "Новости банка": "Banka Haberleri",
    "Мы стали ещё ближе!": "Artık daha yakınız!",
    "Открытие нового офиса в районе Турбаза": "Turbaza bölgesinde yeni ofis açılışı",
    "Скачивайте мобильное приложение": "Amra mobil uygulamasını indirin ve mobil operatörleri uzaktan doldurun!",
    "Карты Visa и Mastercard": "Visa ve Mastercard kartları Abhazistan'da tekrar çalışıyor",
    "Как вести бизнес с турецкими партнерами?": "Türk ortaklarla iş yapmak nasıl olur?",
    "Мы осуществляем переводы": "Türk lirası ile Türkiye'deki tüm bankalara transferler yapıyoruz. Acil bir ödeme göndermeniz gerekiyorsa, size yardımcı olmaya hazırız.",
    "За более подробной информацией по номеру: +7 (840) 227-73-35": "Daha fazla bilgi için: +7 (840) 227-73-35",
    "Онлайн-переводы с карт РФ прямо на карту или счёт Амра-Банк.": "Russya kartlarından Amra Bank kartına veya hesabına doğrudan online transferler."
  },
  "es": {
    "Новости банка": "Noticias del Banco",
    "Мы стали ещё ближе!": "¡Nos hemos acercado aún más!",
    "Открытие нового офиса в районе Турбаза": "Apertura de una nueva oficina en la zona de Turbaza",
    "Скачивайте мобильное приложение": "Descargue la aplicación móvil Amra y recargue operadores móviles de forma remota!",
    "Карты Visa и Mastercard": "Las tarjetas Visa y Mastercard vuelven a funcionar en Abjasia",
    "Как вести бизнес с турецкими партнерами?": "¿Cómo hacer negocios con socios turcos?",
    "Мы осуществляем переводы": "Realizamos transferencias en liras turcas a todos los bancos de Turquía. Si necesita enviar un pago urgentemente, estamos listos para ayudarle.",
    "За более подробной информацией по номеру: +7 (840) 227-73-35": "Para más información, llame al: +7 (840) 227-73-35",
    "Онлайн-переводы с карт РФ прямо на карту или счёт Амра-Банк.": "Transferencias en línea desde tarjetas de la Federación Rusa directamente a una tarjeta o cuenta de Amra Bank"
  },
  "ar": {
    "Новости банка": "أخبار البنك",
    "Мы стали ещё ближе!": "لقد أصبحنا أقرب!",
    "Открытие нового офиса в районе Турбаза": "افتتاح مكتب جديد في منطقة توربازا",
    "Скачивайте мобильное приложение": "قم بتنزيل تطبيق Amra المحمول وأعد شحن شركات الهاتف المحمول عن بُعد!",
    "Карты Visa и Mastercard": "بطاقات فيزا وماستركارد تعمل مرة أخرى في أبخازيا",
    "Как вести бизнес с турецкими партнерами?": "كيف تدير الأعمال مع الشركاء الأتراك؟",
    "Мы осуществляем переводы": "نحن نقوم بإجراء التحويلات",
    "За более подробной информацией по номеру: +7 (840) 227-73-35": "نقوم بإجراء التحويلات بالليرة التركية إلى جميع البنوك في تركيا. لمزيد من المعلومات، اتصل على: +7 (840) 227-73-35",
    "Онлайн-переводы с карт РФ прямо на карту или счёт Амра-Банк.": "التحويلات عبر الإنترنت من بطاقات الاتحاد الروسي مباشرة إلى بطاقة أو حساب بنك أمرا."
  }
}
</i18n>
<template>
  <section class="container mt-6 px-4 lg:px-0 mb-24 md:mb-0">
    <p class="text-xl md:text-4xl font-medium">{{ t("Новости банка") }}</p>

  <section class="grid gap-5 mt-5 mb-5">
    <div
      v-for="(newsItem, index) in news?.slice(0,3)"
      :key="newsItem.id"
          :class="[
      'flex flex-col mt-1 pb-4',
      index !== news.length ? 'border-b border-[#f2f2f2]' : '' 
    ]"
    >
   
    <p class="text-[#a8a8a8] font-sans text-xs md:text-sm lg:text-xs mb-1 ml-7">
      {{ dayjs(newsItem.published_at).locale('ru').format("D MMMM YYYY") }}
    </p>
    
    
    <nuxt-link
    :to="localePath(`/news/${newsItem.id}`)"
    class="text-base md:text-lg lg:text-xl font-sans font-medium flex  gap-2 hover:text-[#FFB800] transition-colors"
    >
    <a-icon-arrow-right/>
        {{ newsItem.title }}
      </nuxt-link>
    </div>
  </section>
    <div class="grid gap-5 lg:gap-[30px] mt-1">
      <div class="grid md:grid-cols-12 md:!h-[311px] gap-5 lg:gap-[30px]">
        <div
         class="md:col-span-6 border border-[#B2B2B2] rounded-xl md:rounded-3xl 
         relative md:px-4 md:py-3 p-2 overflow-hidden 
         bg-gradient-to-r from-[#FFE266] to-[#FFB800] 
         md:bg-white md:bg-none md:hover:bg-gradient-to-r md:hover:from-[#FFE266] md:hover:to-[#FFB800] 
         transition-colors"
        >
          <nuxt-link
            :to="localePath(`/pay-online-24`)"
            class="block h-full w-full"
          >
            <p class="text-md text-center md:text-left md:text-2xl md:text-black font-sans font-medium relative z-10 text-[#555555]">
              {{
                t(
                  "Онлайн-переводы с карт РФ прямо на карту или счёт Амра-Банк."
                )
              }}
            </p>

            <a-icon-news-transaction
              class="absolute inset-0 w-full h-full md:mt-12 hidden md:block"
            />
            <a-icon-news-transaction
              class="block md:hidden mx-auto mt-4 w-full h-full"
            />
          </nuxt-link>
        </div>

        <div
          class="md:col-span-6 border border-[#B2B2B2] rounded-xl md:rounded-3xl relative md:px-4 md:py-3 p-2 overflow-hidden hover:bg-gradient-to-r from-[#FFE266] to-[#FFB800] transition-colors"
        >
          <nuxt-link :to="localePath(`/cards`)" class="block h-full w-full">
            <p class="text-md text-center md:text-left md:text-2xl font-medium relative z-10">
              {{ t("Карта Амра-Банк — уже ждёт вас в офисе!") }}
            </p>
            <a-icon-news-card
              class="absolute inset-0 w-full h-full md:mt-4 hidden md:block"
            />

            <a-icon-news-card class="block md:hidden mx-auto mt-1 w-full h-full" />
          </nuxt-link>
        </div>
        <!-- <div
          class="md:col-span-4 border-[1px] md:flex md:justify-between border-[#B2B2B2] rounded-xl md:rounded-3xl relative md:px-4 md:py-3 p-2"
        ></div> -->
      </div>
      <div class="grid md:grid-cols-11 md:!h-[311px] gap-5 lg:gap-[30px]">
        <!-- <div
                    class="md:col-span-3 shadow-input rounded-xl md:w-auto w-full h-64 md:h-auto md:rounded-t-3xl md:rounded-bl-none relative p-4 overflow-hidden md:border-none border-[1px] border-[#B2B2B2]">
                    <p class="text-sm md:text-3xl font-medium">{{ t('Карты Visa и Mastercard') }}</p>
                    <div class="absolute left-0 bottom-0">
                        <div class="relative w-[172px] h-[177px]">
                            <div
                                class="w-[233px] h-[233px] bg-[#FCC900] rounded-full absolute top-[11px] left-[-61.5px]">
                            </div>
                        </div>
                    </div>
                    <a-icon-card_3 class="absolute bottom-3 -right-20 "></a-icon-card_3>
                </div> -->
        <div
          class="rounded-xl md:rounded-3xl md:col-span-3 bg-gradient-to-r from-[#FFE266] to-[#FFB800] p-4 relative"
        >
          <p class="text-md md:text-xl font-medium text-[#555555] font-sans">
            {{ t("Скачивайте мобильное приложение") }}
          </p>
          <div class="flex place-content-center w-full h-full">
            <a-icon-app class="md:ml-4"></a-icon-app>
          </div>
        </div>
        <div
          class="rounded-xl md:rounded-3xl md:col-span-8 border-[1px] border-[#B2B2B2] p-2 md:p-4 relative md:w-auto w-full h-64 md:h-auto overflow-hidden"
        >
          <div class="md:grid md:grid-cols-12">
            <div class="md:col-span-9 font-sans">
              <p class="text-md md:text-3xl font-medium mb-1 md:mb-0">
                {{ t("Как вести бизнес с турецкими партнерами?") }}
              </p>
              <p class="text-[#3F5963] text-xl md:block hidden mt-1">
                {{ t("Мы осуществляем переводы") }}
              </p>
              <p class="text-[#3F5963] text-xl md:block hidden">
                {{
                  t(
                    "За более подробной информацией по номеру: +7 (840) 227-73-35"
                  )
                }}
              </p>
              <p class="text-[#3F5963] text-sm block md:hidden">
                {{ t("Мы осуществляем переводы") }}
              </p>
            </div>
          </div>
          <div class="block md:hidden">
            <div class="flex place place-content-center w-full h-full">
              <a-icon-flag
                class="absolute bottom-1 md:h-auto h-25"
              ></a-icon-flag>
            </div>
          </div>
          <a-icon-flag
            class="absolute right-0 bottom-0 hidden md:block"
          ></a-icon-flag>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
import dayjs from "dayjs";
import "dayjs/locale/ru";
const localePath = useLocalePath();

import toStrapiLocale from "~/helpers/toStrapiLocale";
const { $get } = useAxios();
const { locale } = useI18n();

const { data: news } = await useAsyncData("get all news", () =>
  $get(`/news?_locale=ru&_sort=published_at:desc`)
);
</script>
